export default {"src":"/_next/static/media/Help.b87cb1e2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};